import Account from "redux/apis/Account"
import ChangedSymbol from "redux/apis/ChangedSymbol"
import Future from "redux/apis/Future"
import InvestmentTrusts from "redux/apis/InvestmentTrusts"
import News from "redux/apis/News"
import Other from "redux/apis/Other"
import SymbolDetail from "redux/apis/SymbolDetail"
import Tool from "redux/apis/Tool"
import Chart from "redux/apis/Chart"
// import * as base64 from "base-64"
// import * as CryptoJS from "crypto-js"
// import AES from "crypto-js/aes"

/**
 * 暗号化
 */
// export const AESEncrypt = (msg) => {
//   const key = CryptoJS.enc.Base64.parse(config.api.auth.key)
//   const iv = CryptoJS.enc.Base64.parse(config.api.auth.iv)
//   const options = {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   }
//   const encrypted = AES.encrypt(msg, key, options)
//   return encrypted.ciphertext.toString()
// }

export default {
  Account,
  ChangedSymbol,
  Future,
  InvestmentTrusts,
  News,
  Other,
  SymbolDetail,
  Tool,
  Chart,
}
